import { EMAIL_REGEX_STR } from 'common/Prose/utils/link'
import React, { useLayoutEffect, useMemo, useRef, useState } from 'react'
import * as validator from 'validator'
import Styles from './LinkForm.module.scss'
import { Input } from 'almanac-ui/TextInputField/Input'
import { Button } from 'blaze-ui/Button'

const EMAIL_REGEX = new RegExp(`^mailto:${EMAIL_REGEX_STR}$`)

const checkUrl = (str: string) => validator.isURL(str) || EMAIL_REGEX.test(str)

export type LinkFormProps = {
  url: string
  isEditing: boolean
  onSave: (newUrl: string) => void
  onCancel: () => void
}

export const LinkForm: React.FC<React.PropsWithChildren<LinkFormProps>> = (props) => {
  const [dirty, setDirty] = useState(false)
  const [url, setUrl] = useState(props.url)
  const inputRef = useRef<HTMLInputElement>(null)

  const isUrlValid = useMemo(() => checkUrl(url), [url])

  useLayoutEffect(() => {
    inputRef.current?.focus()
  }, [inputRef])

  return (
    <div className={Styles.wrapper}>
      <Input
        isValid={dirty ? isUrlValid : true}
        name="url"
        ref={inputRef}
        type="url"
        value={url}
        placeholder="Paste or enter hyperlink"
        onChange={(e) => {
          setDirty(true)
          setUrl(e.target.value)
        }}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && isUrlValid) {
            props.onSave(url)
          }
          if (e.key === 'Escape') {
            props.onCancel()
          }
        }}
      />
      <Button size="sm" variant="tertiary" isDisabled={!isUrlValid} onPress={() => props.onSave(url)}>
        {props.isEditing ? 'Update' : 'Add'}
      </Button>
    </div>
  )
}
